// https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/error-codes/
export const CLOUDFLARE_TURNSTILE_ERROR_CODES = {
  INVALID_CHALLENGE_PARAMETERS: '106010',
  INVALID_SITEKEY: '110100',
  SITEKEY_NOT_FOUND: '110110',
  DOMAIN_NOT_AUTHORIZED: '110200',
  CHALLENGE_TIMEOUT: '110600',
  CHALLENGE_TIMEOUT_RANGE_END: '110609',
  CLOCK_OR_CACHE_PROBLEM: '200100',
  IFRAME_LOAD_ERROR: '200500',
  GENERIC_CHALLENGE_FAILURE_300: '300000',
  GENERIC_CHALLENGE_FAILURE_300_RANGE_END: '300999',
  INVALID_SITEKEY_400020: '400020',
  UNDOCUMENTED_400060: '400060',
  SITEKEY_DISABLED: '400070',
  GENERIC_CHALLENGE_FAILURE_600: '600000',
  GENERIC_CHALLENGE_FAILURE_600_RANGE_END: '600999',
} as const;

export const CLOUDFLARE_TURNSTILE_ERROR_CODE_PATTERNS = {
  CHALLENGE_TIMEOUT: /11060\d/,
  GENERIC_CHALLENGE_FAILURE_300: /300\d{3}/,
  GENERIC_CHALLENGE_FAILURE_600: /600\d{3}/,
} as const;
